import React, { useState } from 'react'

const TECHNOLOGIES = [
  { value: 'solar_pv', label: 'Solar PV' },
  { value: 'wind',     label: 'Wind' },
]

const COUNTRIES = [
  { value: 'indonesia', label: 'Indonesia' },
  { value: 'kenya',     label: 'Kenya' },
  { value: 'vietnam',   label: 'Vietnam' },
]

const CAPACITIES = [1, 5, 10, 20, 50, 100]

export default function AssessControls({ onAssess, loading, lastClick }) {
  const [technology, setTechnology] = useState('solar_pv')
  const [country,    setCountry]    = useState('indonesia')
  const [capacity,   setCapacity]   = useState(10)

  const handleAssess = () => {
    if (!lastClick) return
    onAssess({ lat: lastClick.lat, lon: lastClick.lng, technology, country, capacity_mw: capacity })
  }

  return (
    <div className="card">
      <div className="card__title">Parameters</div>

      <div className="control-row">
        <div className="control-group">
          <label>Technology</label>
          <select value={technology} onChange={e => setTechnology(e.target.value)}>
            {TECHNOLOGIES.map(t => (
              <option key={t.value} value={t.value}>{t.label}</option>
            ))}
          </select>
        </div>
        <div className="control-group">
          <label>Country</label>
          <select value={country} onChange={e => setCountry(e.target.value)}>
            {COUNTRIES.map(c => (
              <option key={c.value} value={c.value}>{c.label}</option>
            ))}
          </select>
        </div>
      </div>

      <div className="control-row">
        <div className="control-group">
          <label>Capacity</label>
          <select value={capacity} onChange={e => setCapacity(Number(e.target.value))}>
            {CAPACITIES.map(c => (
              <option key={c} value={c}>{c} MW</option>
            ))}
          </select>
        </div>
      </div>

      {lastClick ? (
        <div className="site-pin" style={{ marginBottom: 10 }}>
          <span className="site-pin__icon" />
          <span className="site-pin__coords">
            {lastClick.lat.toFixed(5)}, {lastClick.lng.toFixed(5)}
          </span>
        </div>
      ) : (
        <div className="alert alert-info" style={{ marginBottom: 10 }}>
          Click on the map to select a site
        </div>
      )}

      <button
        className="btn btn-primary"
        disabled={!lastClick || loading}
        onClick={handleAssess}
      >
        {loading ? 'Assessing…' : 'Run Assessment'}
      </button>
    </div>
  )
}
